import {IUser} from "../../../../../app/interfaces/user/IUser";
import {IChatSocketCommand} from "../../../../../app/types/ChatSocketCommand";

export const requestNewChatMessagesCommand = (user: IUser): IChatSocketCommand => ({
    cmd: 'new',
    userId: user.uniqueUserValue ?? user.idStr ?? ''
});